import { useNavigate } from 'react-router-dom'
import { useEffect } from "react";

import UserService from "../services/UserService";

function Home() {
	const navigate = useNavigate();
	
	useEffect( () => {
		if (UserService.isAuthenticated()) {
			navigate("/tickets")
		} else {
			navigate("/login")
		}
		
	}, [])
	
}

export default Home;